import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData, sanitizePageDataSearch } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { ProductListPageInitialData } from "./productListPageInitialData";

export const plpPageQueryOptions = (categoryCode: string, search = "") => {
  const sanitizedSearch = sanitizePageDataSearch(search);
  return queryOptions({
    queryKey: pageDataKeys.plp(categoryCode, sanitizedSearch),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<ProductListPageInitialData>>(
        `/page-data/plp/${categoryCode}${sanitizedSearch}`,
      ),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
